import { ResourceUserRoleCategory } from 'src/api';

export type HelpRole = 'employee' | 'employer' | 'verifier' | 'peo';

const HELP_ROLES: readonly HelpRole[] = ['employee', 'employer', 'verifier', 'peo'];

export function isHelpRole(value: string | undefined): value is HelpRole {
  return !!value && (HELP_ROLES as readonly string[]).includes(value);
}

export function resourceCategoryToHelpRole(
  category: ResourceUserRoleCategory | null | undefined,
): HelpRole | null {
  switch (category) {
    case ResourceUserRoleCategory.Employee:
      return 'employee';
    case ResourceUserRoleCategory.Employer:
      return 'employer';
    case ResourceUserRoleCategory.Verifier:
      return 'verifier';
    case ResourceUserRoleCategory.Peo:
    case ResourceUserRoleCategory.PeoPayrollProvider:
      return 'peo';
    default:
      return null;
  }
}
